import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsV8Component } from './simple-icons-v8.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsV8Component ],
    exports:      [ SimpleIconsV8Component ],
    bootstrap:    []
})
export class SimpleIconsV8Module {}
